import { faBuilding, faTelescope } from '@fortawesome/pro-duotone-svg-icons';
import { GridApi } from 'ag-grid-community';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import {
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
import { HideIfNotAllowed } from 'components/organisms/permission-controller';
import { PermissionRuleName, RoutePaths } from 'constant';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  && {
    padding-top: var(--spacing-08);
    padding-bottom: var(--spacing-08);
  }
`;

export const NoResultProjectListEmptyState: FC<{ api: GridApi }> = ({
  api,
}) => {
  const isEmpty = api.getModel().isEmpty();

  return (
    <EmptyStateContainer>
      {isEmpty ? (
        <EmptyState
          image={<EmptyStateIcon icon={faBuilding} />}
          title={<FormattedMessage id="projects.empty.title" />}
          message={<FormattedMessage id="projects.empty.message" />}
          primaryCTA={
            <HideIfNotAllowed ruleName={PermissionRuleName.ProjectCreateAction}>
              <Link
                component={EmptyState.CallToAction.Primary}
                to={RoutePaths.projectCreate}
              >
                <FormattedMessage id="projects.empty.primary" />
              </Link>
            </HideIfNotAllowed>
          }
          secondaryCTA={
            <HideIfNotAllowed ruleName={PermissionRuleName.TemplatePage}>
              <Link
                component={EmptyState.CallToAction.Secondary}
                to={RoutePaths.templates}
              >
                <FormattedMessage id="projects.empty.secondary" />
              </Link>
            </HideIfNotAllowed>
          }
        />
      ) : (
        <EmptyState
          image={<EmptyStateIcon icon={faTelescope} />}
          title={<FormattedMessage id="projects.no_results.empty.title" />}
          message={<FormattedMessage id="projects.no_results.empty.message" />}
          secondaryCTA={null}
        />
      )}
    </EmptyStateContainer>
  );
};
